.<template>
  <div class="Process_h">
    <el-col :span="6">
      <h4><span>丨</span>报名流程</h4>
      <!-- <el-menu class="">
        <el-submenu>
          <template #title>
            <span>1.网上报名</span>
          </template>
          <el-menu-item-group>
            <el-menu-item>（1）阅读报名须知并签订诚信承诺书</el-menu-item>
            <el-menu-item @click="goView('/enroll')"
              >（2）填写报名信息
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item>
          <template #title
            ><div @click="goView('/result')">2.查询审核结果</div>
          </template>
        </el-menu-item>
        <el-submenu>
          <template #title>
            <span>3.考试</span>
          </template>
          <el-menu-item-group v-for="(item, index) in menuList" :key="index">
            <el-menu-item>{{ item.name }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item>
          <template #title>4.拟聘用人员公示</template>
        </el-menu-item>
      </el-menu> -->

      <div class="Process">
        <h5>1.网上报名</h5>
        <ul>
          <li>（1）阅读报名须知并签订诚信承诺书</li>
          <li>（2）填写报名信息</li>
        </ul>
        <h5>2.查询审核结果</h5>
        <!--  -->
        <h5>3.考试</h5>
        <ul>
          <li>（1）笔试通知</li>
          <li>（2）网上笔试缴费</li>
          <li>（3）打印笔试准考证</li>
          <li>（4）笔试成绩查询</li>
          <li>（5）面试通知</li>
          <li>（6）网上面试缴费</li>
          <li>（7）打印面试准考证</li>
          <li>（8）综合成绩查询</li>
        </ul>
        <h5>4.拟聘用人员公示</h5>
      </div>
    </el-col>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    goView(path) {
      this.$router.push(path);
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.el-col {
  border-right: 1px solid #a0a0a0;
  padding-right: 0.2rem;
  min-height: 13rem;

  h4 {
    font-size: 0.42rem;
    padding-left: 0.82rem;
    padding-top: 0.6rem;
    padding-bottom: 0.85rem;
    span {
      color: #00a0e9;
    }
  }
}
.Process {
  padding-left: 1.05rem;
  h5 {
    font-size: 0.38rem;
    color: #000;
    font-weight: normal;
    padding: 0.1rem 0;
  }
  ul {
    li {
      font-size: 0.24rem;
      padding: 0.15rem 0;
    }
  }
}
</style>
